import { useEffect } from 'react';
import { relewiseTrackingService } from '../TrackingService';

const STORAGE_KEY = 'relewise_user_logged_in';

const setLoggedInState = (isAuthenticated: boolean) => {
    localStorage.setItem(STORAGE_KEY, String(isAuthenticated));
};
const getLoggedInState = () => {
    const storedValue = localStorage.getItem(STORAGE_KEY);
    return storedValue === null ? undefined : storedValue === 'true';
};

export const useUserUpdateTracker = (isAuthenticated: boolean | undefined) => {
    useEffect(() => {
        if (isAuthenticated === undefined) {
            return;
        }

        const previousState = getLoggedInState();
        if (previousState === undefined) {
            setLoggedInState(isAuthenticated);
            return;
        }

        if (previousState === isAuthenticated) {
            return;
        }

        setLoggedInState(isAuthenticated);

        // Only track user update if the user has logged in
        if (isAuthenticated) {
            relewiseTrackingService.trackUserUpdate();
        }
    }, [isAuthenticated]);
};
